module.exports = __webpack_public_path__ + "static/img/logo.185cd88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 23
// module chunks = 0